export const POSITION_LOT_TYPES = ['product', 'packaging'] as const
export type PositionLotType = (typeof POSITION_LOT_TYPES)[number]

/**
 * Bộ lọc Tồn theo vị trí (trên URL). Tồn là số HIỆN TẠI nên không có kỳ.
 * `types`: chỉ vị trí dùng cho loại hàng đó; `hideEmpty`: ẩn vị trí trống.
 */
export interface PositionReportSearch {
    q?: string
    types?: PositionLotType[]
    hideEmpty?: boolean
}

export function validatePositionReportSearch(
    raw: Record<string, unknown>,
): PositionReportSearch {
    const parts = Array.isArray(raw.types)
        ? raw.types.map(String)
        : typeof raw.types === 'string'
          ? raw.types.split(',')
          : []
    const types = POSITION_LOT_TYPES.filter((t) => parts.includes(t))
    return {
        q: typeof raw.q === 'string' && raw.q.trim() ? raw.q : undefined,
        types: types.length > 0 ? types : undefined,
        hideEmpty:
            raw.hideEmpty === true || raw.hideEmpty === 'true'
                ? true
                : undefined,
    }
}
